import { Fragment } from 'react';

import Edit2 from '@crehana/icons/outline/Edit2';
// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import { Clamp, colors } from '@crehana/ui';

import Steps from '@/views/B2BCheckout/components/Steps';
import { ACTIONS } from '@/views/B2BCheckout/context/types';
import useCheckoutCtx from '@/views/B2BCheckout/hooks/useCheckoutCtx';

const { primaryMain } = colors;

const UserInfo = () => {
  const {
    dispatch,
    ONBOARDING_STEPS,
    state: { currentStep, accountDetails },
  } = useCheckoutCtx();

  // TODO: Retrieve oportunity nad veify if it was created else return error

  return (
    <Fragment>
      <Steps
        currentStep={currentStep}
        steps={ONBOARDING_STEPS}
        className="mb-32 sm:mb-56"
      />
      <p className="font-label mb-12">Confirma información</p>
      <div className="p-24 border border-solid border-gray-main rounded-5 bg-gray-lighter mb-40">
        <div className="flex justify-between mb-12">
          <p className="font-subtitle4">Detalle de Cuenta</p>
          <button
            type="button"
            className="flex items-center font-caption text-primary-main"
            onClick={() => {
              dispatch({
                type: ACTIONS.NAVIGATE,
                payload: 2,
              });
            }}
          >
            <Edit2 size={16} color={primaryMain} className="mr-4" />
            Editar info
          </button>
        </div>
        <div className="flex items-center">
          <div className="w-1/2">
            <Clamp clamp={1} className="font-body4 mb-4">
              {accountDetails?.firstName} {accountDetails?.lastName}
            </Clamp>
            <Clamp clamp={1} className="font-body4 mb-4">
              {accountDetails?.phoneNumber.code}{' '}
              {accountDetails?.phoneNumber.phoneNumber}
            </Clamp>
            <Clamp clamp={1} className="font-body4">
              {accountDetails?.email}
            </Clamp>
          </div>
          <div className="w-1/2">
            <Clamp clamp={1} className="font-body4 mb-4">
              {accountDetails?.role}
            </Clamp>
            <Clamp clamp={1} className="font-body4 mb-4">
              {accountDetails?.company}
            </Clamp>
            <Clamp clamp={1} className="font-body4 mb-4">
              {accountDetails?.docNroCompany}
            </Clamp>
            <Clamp clamp={1} className="font-body4">
              {accountDetails?.country?.label}
            </Clamp>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default UserInfo;
